export default {"src":"/_next/static/media/chevron-right-green.c8f54a18.svg","height":24,"width":24};